import type { FC, PropsWithChildren } from 'react';

import classNames from 'classnames';

import classes from './DialogContent.module.scss';

export const DialogContent: FC<PropsWithChildren<{ className?: string }>> = ({ className, children }) => {
  return (
    <div className={classNames(classes.content, className)}>
      <div className={classes.patternImage} />
      {children}
    </div>
  );
};
